import { ReportColumnPersonalizationFlags } from 'src/utils/columns/columnUtils.types';
import { COMMISSION_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from 'src/utils/columns/commission/commissionColumnUtils.constants';
import { COST_OF_GOODS_SOLD_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from 'src/utils/columns/costOfGoodsSold/costOfGoodsSoldColumnUtils.constants';
import { LISTING_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from 'src/utils/columns/inventory/inventoryColumnUtils.constants';
import { PURCHASE_ORDER_LINE_ITEM_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from 'src/utils/columns/purchaseOrderLineItem/purchaseOrderLineItemColumnUtils.constants';
import { PURCHASE_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from 'src/utils/columns/purchases/purchasesColumnUtils.constants';
import { SALE_COST_ADJUSTMENTS_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from 'src/utils/columns/saleCostAdjustments/saleCostAdjustmentsColumnUtils.constants';
import { SALE_LINE_ITEM_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from 'src/utils/columns/saleLineItem/saleLineItemColumnUtils.constants';
import { SALE_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from 'src/utils/columns/sales/salesColumnUtils.constants';
import { SOLD_TICKET_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from 'src/utils/columns/soldTicket/soldTicketColumnUtils.constants';
import { TICKET_GROUP_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES } from 'src/utils/columns/ticketGroup/ticketGroupColumnUtils.constants';
import { ContentId } from 'src/utils/constants/contentId';
import {
  COMMISSION_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  COMMISSION_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  COST_OF_GOODS_SOLD_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  COST_OF_GOODS_SOLD_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  LISTING_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  LISTING_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  PURCHASE_LINE_ITEM_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  PURCHASE_LINE_ITEM_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  PURCHASE_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  PURCHASE_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  SALE_COST_ADJUSTMENTS_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  SALE_COST_ADJUSTMENTS_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  SALE_LINE_ITEM_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  SALE_LINE_ITEM_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  SALES_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  SALES_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  SOLD_TICKET_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  SOLD_TICKET_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  TICKET_GROUP_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  TICKET_GROUP_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
} from 'src/utils/constants/contentIdMaps';
import { ReportTypesV2 } from 'src/utils/reportsUtils';
import { UserSetting } from 'src/WebApiController';

export const REPORT_TYPE_TO_GROUPING_CONTENT_OPTIONS: Record<
  ReportTypesV2,
  Record<string, ContentId>
> = {
  [ReportTypesV2.InventoryV2]:
    LISTING_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.SaleV2]: SALES_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.Commission]:
    COMMISSION_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.Purchase]:
    PURCHASE_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.SaleLineItem]:
    SALE_LINE_ITEM_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.PurchaseOrderLineItem]:
    PURCHASE_LINE_ITEM_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.SoldTicket]:
    SOLD_TICKET_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.CostOfGoodsSold]:
    COST_OF_GOODS_SOLD_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.SaleCostAdjustments]:
    SALE_COST_ADJUSTMENTS_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.TicketGroup]:
    TICKET_GROUP_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID,
};

export const REPORT_TYPE_TO_VALUE_CONTENT_OPTIONS: Record<
  ReportTypesV2,
  Record<string, ContentId>
> = {
  [ReportTypesV2.InventoryV2]:
    LISTING_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.SaleV2]: SALES_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.Commission]:
    COMMISSION_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.Purchase]: PURCHASE_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.SaleLineItem]:
    SALE_LINE_ITEM_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.PurchaseOrderLineItem]:
    PURCHASE_LINE_ITEM_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.SoldTicket]:
    SOLD_TICKET_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.CostOfGoodsSold]:
    COST_OF_GOODS_SOLD_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.SaleCostAdjustments]:
    SALE_COST_ADJUSTMENTS_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
  [ReportTypesV2.TicketGroup]:
    TICKET_GROUP_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID,
};

export const REPORT_TYPE_TO_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  ReportTypesV2,
  Record<string, Partial<ReportColumnPersonalizationFlags>>
> = {
  [ReportTypesV2.InventoryV2]:
    LISTING_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  [ReportTypesV2.SaleV2]:
    SALE_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  [ReportTypesV2.Commission]:
    COMMISSION_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  [ReportTypesV2.Purchase]:
    PURCHASE_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  [ReportTypesV2.SaleLineItem]:
    SALE_LINE_ITEM_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  [ReportTypesV2.SoldTicket]:
    SOLD_TICKET_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  [ReportTypesV2.PurchaseOrderLineItem]:
    PURCHASE_ORDER_LINE_ITEM_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  [ReportTypesV2.CostOfGoodsSold]:
    COST_OF_GOODS_SOLD_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  [ReportTypesV2.SaleCostAdjustments]:
    SALE_COST_ADJUSTMENTS_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
  [ReportTypesV2.TicketGroup]:
    TICKET_GROUP_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES,
};

export const REPORT_TYPE_TO_CUSTOM_COLUMN_USER_SETTING_ID: Record<
  ReportTypesV2,
  UserSetting
> = {
  [ReportTypesV2.InventoryV2]: UserSetting.ReportCustomColumnInventory,
  [ReportTypesV2.SaleV2]: UserSetting.ReportCustomColumnSales,
  [ReportTypesV2.SaleLineItem]: UserSetting.ReportCustomColumnSaleLineItem,
  [ReportTypesV2.PurchaseOrderLineItem]: UserSetting.ReportCustomColumnPurchase,
  [ReportTypesV2.SoldTicket]: UserSetting.ReportCustomColumnSoldTicket,
  [ReportTypesV2.Purchase]: UserSetting.ReportCustomColumnPurchase,
  [ReportTypesV2.Commission]: UserSetting.ReportCustomColumnCommission,
  [ReportTypesV2.CostOfGoodsSold]:
    UserSetting.ReportCustomColumnCostOfGoodsSold,
  [ReportTypesV2.SaleCostAdjustments]:
    UserSetting.ReportCustomColumnSaleCostAdjustments,
  [ReportTypesV2.TicketGroup]: UserSetting.ReportCustomColumnTicketGroup,
};
